import { Reducer } from 'redux';

import { ActionTypes, DomainState } from './types';

const defaultState = {
    loadingDomains: false,
    loadedDomains: false,
};

const reducer: Reducer<DomainState> = (state: DomainState = defaultState, action): DomainState => {
    const { payload, type } = action;
    switch (type) {
        case ActionTypes.DOMAIN_FETCH_START:
        case ActionTypes.DOMAIN_ADD_START:
            return {
                ...state,
                loadingDomains: true,
                loadedDomains: false,
            };
        case ActionTypes.DOMAIN_FETCH_ERROR:
        case ActionTypes.DOMAIN_ADD_FINISH:
            return {
                ...state,
                loadingDomains: false,
            };
        case ActionTypes.DOMAIN_UPDATE_SUCCESS:
        case ActionTypes.DOMAIN_FETCH_SUCCESS:
            return {
                ...state,
                loadingDomains: false,
                loadedDomains: true,
                domains: payload.domains,
            };
        case ActionTypes.DOMAIN_FETCH_SINGLE_SUCCESS:
            return {
                ...state,
                ...{ singleDomain: payload.specificDomain },
            };
        case ActionTypes.DOMAIN_DELETE_SUCCESS:
        case ActionTypes.DOMAIN_CLEAR_SINGLE_DOMAIN:
            return {
                ...state,
                ...{ singleDomain: {} },
            };
        default:
            return state;
    }
};

export { reducer as domain };

export default reducer;
